import Layout from "../components/Layout/Layout";

const CodeOfConduct = () => {
    return (
    <Layout>
      <div className="container mx-auto p-6 my-10">
        <h1 className="text-4xl font-bold mb-10 text-center">Classroom of Conduct</h1>
        <p className="mb-4">
          ProSafe Training School is committed to providing a safe and productive learning environment in which all individuals are treated with respect and dignity. To that end students, instructors, and staff are expected to:
        </p>
        <ul className="list-disc pl-6 space-y-2 bg-gray-50 p-5 shadow-md rounded-lg">
          <li>
            Treat fellow students, instructors, visitors, and staff of ProSafe Training School with courtesy and respect at all times. ProSafe Training School does not tolerate any forms of bullying or harassment. Refrain from making any comments/jokes of sexual, religious, political, discriminatory or racial nature. Any improper activity, behaviour or harassment should be reported immediately to the instructor and/or ProSafe staff.
          </li>
          <li>
            Arrive at class on time and be in the assigned place with appropriate materials ready to work in close contact with fellow students. Your first priority at school is to learn. Avoid distractions that interfere with or are counter-intuitive to that mission and avoid being a distraction for others trying to learn.
          </li>
          <li>
            Refrain from any improper activity or behaviour that might create or constitute a hazard or threatening environment to themselves or any other person. Horseplay is not permitted, especially when dealing with equipment such as oxygen tanks, spinal boards, tourniquets, etc.
          </li>
          <li>
            Keep all cell phones on vibrate/silent to avoid disturbing others in the class. Students should not be using cell phones or other devices during class time. Taking photographs or videos of classroom activity is only allowed with the expressed approval of all involved.
          </li>
          <li>
            Do your part to keep the classroom and common areas clean and free from garbage. Keep your training supplies and classroom work area neat and organized and tidy up after yourself when using the kitchen.
          </li>
          <li>
            All training equipment must be used as directed by the instructor, and be treated in a professional and respectful manner.
          </li>
        </ul>
        <p className="mt-4">
          Students who violate the Code of Conduct may be asked to leave the class and the campus. Copies of the Bullying and Harassment policy and the Candidate Complaints policy are available upon request.
        </p>
      </div>
    </Layout>
    );
  };
  
  export default CodeOfConduct;
  